var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.settingsMessageManager.havePreviewMedia)?_c('a-alert',{staticClass:"h-full w-full z-10",attrs:{"message":_vm.$t('field_editor_options_disable_link_preview_title').toString(),"description":"В медиа файлах обнаружено превью, для корректной работы поле было отключено","type":"warning"}}):_c('switch-input',{attrs:{"setup":{
      'func': _vm.inputConfig,
      'args': {
        model: _vm.settingsMessageManager.fields,
        'key': 'disable_link_preview',
        'prefix': 'editor_options_',
        'tariffTags': _vm.tariffTags,
        'disabled': _vm.disabled || _vm.settingsMessageManager.havePreviewMedia,
      },
    }}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }